module.exports = __webpack_public_path__ + "img/add_desktop_3.41e1a4c7.png";